import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import UnitButton from './UnitButton';

export default class UnitButtonBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      i: 0
    };
  }

  componentDidMount() {
    document.addEventListener("keydown", (e) => {
      this.onArrowDown(e.key);
    });
  }

  highlight = (value) => {
    let i = this.props.buttonValues.indexOf(value);
    this.setState({ selected: value, i });
    this.props.onEvent(value);
    this.props.change(i);
  }

  onArrowDown = (key) => {
    if(this.props.buttonValues) {
      const arr = this.props.buttonValues;
      let i = this.state.i;
      let selected = arr[i];
      key === "ArrowLeft"
        ? selected = arr[i = i > 0 ? i-1 : arr.length-1]
        : key === "ArrowRight"
            ? selected = arr[i = i < arr.length-1 ? i+1 : 0]
            : ""
      this.setState({ i });
      this.highlight(selected);
    }
  }

  render() {
    return (
      <div className={cx("button-box", this.props.classname)}>
        <div className="title">
          <h3>{this.props.title}</h3>
        </div>
        <div className="buttons">
          {this.props.buttonValues.map(
                    (val, i) => (
                      <UnitButton selected={val === this.state.selected}
                              value={val}
                              label={(Number(val))}
                              highlight={this.highlight}
                              key={i}

                        />
                      ))}
        </div>
      </div>
    );
  }
}

UnitButtonBox.propTypes = {
  title: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/UnitButtonBox.js